import { Sparkle } from "lucide-react";

const ITEMS = ["Handwritten Notes", "Formula Sheets", "PYQ Solutions", "Video Courses", "Mock Test Series", "Instant PDF Download", "Topper Mindmaps", "Exam Planners"];

function Strip({ hidden }) {
  return (
    <div className="flex items-center shrink-0" aria-hidden={hidden}>
      {ITEMS.map((t) => (
        <span key={t} className="flex items-center gap-8 pr-8">
          <span className="font-display text-sm sm:text-base font-extrabold uppercase tracking-[0.14em] whitespace-nowrap">{t}</span>
          <Sparkle size={14} className="shrink-0" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="relative bg-amber-500 text-ink py-3.5 overflow-hidden marquee-band" data-testid="editorial-marquee">
      <div className="marquee-track flex">
        <Strip /><Strip hidden />
      </div>
    </div>
  );
}
